import {
  FETCH_PAYMENT_HISTORIES_FAILURE,
  FETCH_PAYMENT_HISTORIES_REQUEST,
  FETCH_PAYMENT_HISTORIES_SUCCESS,
  FETCH_PAYMENT_HISTORY_DETAILS_FAILURE,
  FETCH_PAYMENT_HISTORY_DETAILS_REQUEST,
  FETCH_PAYMENT_HISTORY_DETAILS_SUCCESS,
  FETCH_RECEIPT_USER_DETAILS_FAILURE,
  FETCH_RECEIPT_USER_DETAILS_REQUEST,
  FETCH_RECEIPT_USER_DETAILS_SUCCESS,
  LOGOUT,
  SET_CLIENT_SECRET,
  SET_CONNECTED_ACCOUNT_DATA,
  SET_PAYMENT_METHODS,
  SET_REFERRAL_DETAILS,
} from "../actions/action.types";

const initialState = {
  clientSecret: "",
  accountDetails: [],
  paymentMethods: {
    cards: [],
    banks: [],
  },
  // paymentHistories: [],
  // hasMore: false,
  // currentPage: 1,
  paymentHistories: {
    data: [],
    hasMore: false,
    page: 1,
  },
  paymentHistoryDetails: [],
  loading: false,
  error: null,
};

const paymentReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CLIENT_SECRET:
      return { ...state, clientSecret: payload };
    case SET_CONNECTED_ACCOUNT_DATA:
      return { ...state, accountDetails: payload };
    case SET_REFERRAL_DETAILS:
      return { ...state, referralDetails: payload };
    case SET_REFERRAL_DETAILS:
      return { ...state, referralDetails: payload };
    case SET_PAYMENT_METHODS:
      return { ...state, ...payload };
    case FETCH_PAYMENT_HISTORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PAYMENT_HISTORIES_SUCCESS:
      console.log("payload", payload);
      const { paymentHistories, hasMore, page } = payload;
      console.log("paymentHistories", paymentHistories);
      return {
        ...state,
        loading: false,
        paymentHistories: paymentHistories,
        currentPage: payload.page,
        error: null,
      };
    case FETCH_PAYMENT_HISTORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        transactions: null,
      };
    case FETCH_PAYMENT_HISTORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PAYMENT_HISTORY_DETAILS_SUCCESS:
      const { paymentHistoryDetails } = payload;
      return {
        ...state,
        loading: false,
        paymentHistoryDetails: paymentHistoryDetails,
      };
    case FETCH_PAYMENT_HISTORY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        paymentHistoryDetails: null,
      };
    case FETCH_RECEIPT_USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_RECEIPT_USER_DETAILS_SUCCESS:
      const { receiptUserDetails } = payload;
      return {
        ...state,
        loading: false,
        receiptUserDetails,
      };
    case FETCH_RECEIPT_USER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
        receiptUserDetails: null,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default paymentReducer;
